export class TextoVM{
    codigo: number;
    titulo: string;
    descripcion: string;
    seleccionado: boolean;

    constructor(codigo: number, titulo: string, descripcion: string, seleccionado: boolean=false){
        this.codigo=codigo;
        this.titulo=titulo;
        this.descripcion=descripcion;
        this.seleccionado=seleccionado;
    }
}